<table class="table table-striped">
  <thead>
  <tr>
    <th>{{ 'home.preorders.overview.table.head.reference' | translate }}</th>
    <th>{{ 'home.preorders.overview.table.head.eventDescription' | translate }}</th>
    <th>{{ 'home.preorders.overview.table.head.paymentAmount' | translate }}</th>
    <th>{{ 'home.preorders.overview.table.head.paymentProvider' | translate }}</th>
    <th>{{ 'home.preorders.overview.table.head.status' | translate }}</th>
    <th>{{ 'home.preorders.overview.table.head.created' | translate }}</th>
    <th>{{ 'home.preorders.overview.table.head.updated' | translate }}</th>
  </tr>
  </thead>
  <tbody>
  <ng-container *ngIf="preorders.length > 0; else noEntries">
    <tr *ngFor="let p of preorders" (click)="onOpenDetails(p.reference)">
      <td>{{ p.reference }}</td>
      <td>
        {{ p.eventId }}
        <span *ngIf="p.eventDescription">({{ p.eventDescription }})</span>
      </td>
      <td>{{ p.payment ? (p.payment.amount/100 | currency:p.payment.currency) : '—' }}</td>
      <td>{{ p.payment ? ('shared.payment-provider.' + p.payment.paymentProvider | translate) : '—' }}</td>
      <td>{{ 'home.preorders.overview.table.status.' + p.status | translate }}</td>
      <td>{{ p.created | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
      <td>{{ p.updated | date:'dd.MM.yyyy, HH:mm:ss' }}</td>
    </tr>
  </ng-container>
  <ng-template #noEntries>
    <tr>
      <td colspan="7">
        {{ 'home.preorders.overview.table.no-entries' | translate }}
      </td>
    </tr>
  </ng-template>
  </tbody>
</table>
